module.exports = __webpack_public_path__ + "static/img/naturalCircle2h.5a9acc8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/naturalCircle2h.svg
// module id = v2HR
// module chunks = 1